module.exports = __webpack_public_path__ + "static/caseStudySplash-62ff888e2caf4327701ee4e3e25299fa.jpg";